import React from 'react';
import { Handshake, Landmark, Hammer, ClipboardCheck, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../data/mock';

const iconMap = {
  Handshake: Handshake,
  Landmark: Landmark,
  Hammer: Hammer,
  ClipboardCheck: ClipboardCheck
};

export const Services = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToNetwork = () => {
    const element = document.getElementById('netzwerk');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-28 bg-atob-blue">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <span className="inline-flex items-center gap-2 text-atob-orange font-semibold text-sm uppercase tracking-[0.2em] mb-5">
            <span className="h-px w-8 bg-atob-orange"></span>
            Unsere Leistungen
            <span className="h-px w-8 bg-atob-orange"></span>
          </span>
          <h2
            data-testid="services-headline"
            className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-[1.05]"
          >
            Vier Kernbereiche.{' '}
            <span className="text-atob-orange italic font-serif">Ein Ansprechpartner.</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
            Wir sind Ihre Berater – die Umsetzung machen die richtigen Experten
            aus unserem Netzwerk.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-6xl mx-auto mb-14">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon] || Handshake;
            return (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="group relative border border-white/10 hover:border-atob-orange/60 rounded-2xl p-7 md:p-9 transition-all duration-500 cursor-pointer bg-white/[0.02] backdrop-blur-sm hover:bg-white/[0.05] hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-atob-orange/20 flex flex-col"
                style={{ animation: `fadeInUp 0.6s ease-out ${index * 0.12}s both` }}
                onClick={scrollToContact}
              >
                {/* Number */}
                <div className="flex items-start justify-between mb-6">
                  <div className="w-16 h-16 bg-atob-orange/10 rounded-xl flex items-center justify-center group-hover:bg-atob-orange/20 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500">
                    <Icon className="h-8 w-8 text-atob-orange" strokeWidth={1.75} />
                  </div>
                  <div className="text-6xl font-black text-atob-orange/15 leading-none group-hover:text-atob-orange/30 transition-colors duration-300">
                    0{index + 1}
                  </div>
                </div>

                <p className="text-atob-orange text-xs font-bold uppercase tracking-[0.2em] mb-2">
                  {service.tagline}
                </p>

                <h3 className="text-2xl md:text-[1.6rem] font-bold text-white mb-4 leading-tight group-hover:text-atob-orange transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-gray-300 leading-relaxed mb-6 flex-1">
                  {service.description}
                </p>

                <div className="flex items-center gap-2 text-atob-orange font-semibold text-sm opacity-70 group-hover:opacity-100 group-hover:gap-3 transition-all duration-300 mt-auto">
                  <span>Persönlich besprechen</span>
                  <ArrowRight className="h-4 w-4" />
                </div>

                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-atob-orange/10 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
              </div>
            );
          })}
        </div>

        {/* Bridge to network */}
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-300 mb-5 text-base md:text-lg">
            Sie fragen sich, wer das alles konkret liefert?
          </p>
          <Button
            onClick={scrollToNetwork}
            data-testid="services-to-network-cta"
            variant="outline"
            className="bg-transparent text-atob-orange border-atob-orange/60 hover:bg-atob-orange hover:text-atob-blue hover:border-atob-orange font-bold px-8 py-6 text-base"
          >
            Zu unserem Netzwerk
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};
